/* ar-brown App (C) 2021 arbrown.co.jp All rights reserved.
 *******************************************************************************
 * Program ID:  ArFukuiWHSeinoLTList.js
 * $Revision:   Ver1.0
 * $Modtime:    $
 *******************************************************************************
 * Author      (作成／更新年月日、担当者)
 *  2024/11/28 Rayoo)niu : 新規作成
 *
 * Summary ArFukuiWHSeinoLTList画面
 *
 * Instructions / Preconditions
 *  なし
 *
 *******************************************************************************
 */
// pages
import React, { useEffect, useState } from "react";
/*  GraphQL API Acess */
import API, { graphqlOperation } from "@aws-amplify/api";
import { listALLArFukuiWHSeinoLT } from "../graphql/queries";
/*  AWS標準設定 with Login Auth. */
import Amplify from "aws-amplify";
import awsconfig from "../aws-exports";
Amplify.configure(awsconfig);
import { Container ,Row,Col,InputGroup} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  fixedTop: {
    position: "sticky",
    top: 0,
    boxShadow: "0 -1px 0 0 white,0 3px 0 0 #804F29,0 3px 0 0 transparent",
    backgroundColor: "white",
    zIndex: 9,
  },
  textFieldSearch:{
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    background: "transparent",
    border: "1px solid #707070",
    borderRadius: "6px",
    color: "black",
    width:"80%"
  },
  textlabelSearch:{
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    background: "rgb(91,56,9)",
    border: "1px solid #707070",
    color: "white",
    fontWeight: "bold",
    fontSize: '14px',
    alignItems: 'center',
    justifyContent: 'center',
    width:"20%"
  }
}));
const customTotal = (from, to, size) => (
  <span
    style={{ marginLeft: "1em" }}
    className="react-bootstrap-table-pagination-total"
  >
    {size} の結果の {from} から {to} を表示しています
  </span>
);
const pageButtonRenderer = ({ page, onPageChange }) => {
  const handleClick = (e) => {
    e.preventDefault();
    onPageChange(page);
  };
  return (
    <button className="btn-secondary btn" type="button" key={page}>
      <li className="page-item">
        <a style={{ color: "white" }} href="#" onClick={handleClick}>
          {page}
        </a>
      </li>
    </button>
  );
};

const sizePerPageRenderer = ({
  options,
  currSizePerPage,
  onSizePerPageChange,
}) => (
  <div className="btn-group" role="group">
    {options.map((option) => (
      <button
        key={option.text}
        type="button"
        onClick={() => onSizePerPageChange(option.page)}
        className={`btn ${
          currSizePerPage === `${option.page}` ? "btn-warning" : "btn-light"
        }`}
      >
        {option.text}
      </button>
    ))}
  </div>
);
const options = {
  paginationSize: 10,
  pageStartIndex: 1,
  showTotal: true,
  withFirstAndLast: true,
  firstPageText: "最初",
  prePageText: "戻る",
  nextPageText: "次へ",
  lastPageText: "最後",
  nextPageTitle: "最初のページ",
  prePageTitle: "プレページ",
  firstPageTitle: "次のページ",
  lastPageTitle: "最後のページ",
  paginationTotalRenderer: customTotal,
  sizePerPageRenderer: sizePerPageRenderer,
  pageButtonRenderer: pageButtonRenderer,
  disablePageTitle: true,
  sizePerPageList: [
    {
      text: "10",
      value: 10,
    },
    {
      text: "20",
      value: 20,
    },
    {
      text: "30",
      value: 30,
    },
  ],
};

export const ArFukuiWHSeinoLTList = () => {
  const [ArFukuiWHSeinoLTList, setArFukuiWHSeinoLTList] = useState([]);
  const [ArFukuiWHSeinoLTListCopy, setArFukuiWHSeinoLTListCopy] = useState([]);
  const [progress, setProgress] = useState(false);
  const classes = useStyles();
  const [leadTimeList, setleadTimeList] = useState([])
  const [PostCodeList, setPostCodeList] = useState([])
  const [PrefecturesList, setPrefecturesList] = useState([])
  const [PrefectureKanaList, setPrefectureKanaList] = useState([])
  const [MunicipalitiesList, setMunicipalitiesList] = useState([])
  const [CityKanaList, setCityKanaList] = useState([])
  const [TownNameList, setTownNameList] = useState([])
  const [TownNameKanaList, setTownNameKanaList] = useState([])
  const [searchValue, setSearchValue] = useState({
    PostCode: "",
    leadTime:"",
    PrefectureKana:"",
    Prefectures:"",
    Municipalities:"",
    CityKana:"",
    TownName:"",
    TownNameKana:"",
  })
  const searchValueChange = (e,value,name) => {
    setSearchValue({ ...searchValue, [name]: value ? value : "" })
  }
  const searchBtn = async () => {
    setProgress(true)
    let arr = [];
    let dataAll = [];
    let obj = {};
      dataAll = ArFukuiWHSeinoLTListCopy
      obj = searchValue;
      dataAll.forEach(item => {
          let flag = true
          if (Object.keys(obj).length !== 0) {
            for (let name in obj) {
              if (obj[name] !== "") {
                if (item[name]) {
                  if (!(item[name]).includes(obj[name])) {
                    flag = false;
                    break;
                  }
                } else {
                  flag = false
                  break;
                }
              }
            }
          }
          if (flag === true) {
            arr.push(item)
          }
      })
      arr = multiSort(arr,sortByPostCode)
      setArFukuiWHSeinoLTList(arr);
      setProgress(false)
  }
  const searchClear = async()=>{
    setProgress(true)
    let arr = [];
      arr = ArFukuiWHSeinoLTListCopy
      arr = multiSort(arr,sortByPostCode)
      setSearchValue({ PostCode: "",
        leadTime:"",
        PrefectureKana:"",
        Prefectures:"",
        Municipalities:"",
        CityKana:"",
        TownName:"",
        TownNameKana:"",})
      setArFukuiWHSeinoLTList(arr);
      setProgress(false)
  }
  const sortByPostCode = (a, b)=> {
    if (!a.PostCode) {
      return 1;
    } else if (!b.PostCode) {
      return 1;
    } else {
      return a.PostCode.localeCompare(b.PostCode)
    }
  }
  const sortByLeadTime = (a, b)=> {
    if (!a) {
      return 1;
    } else if (!b) {
      return 1;
    } else {
      return a.localeCompare(b)
    }
  }
  const multiSort = (arr, ...sortFuncs)=> {
    return arr.sort((a, b) => {
      for (const func of sortFuncs) {
        const result = func(a, b);
        if (result !== 0) {
          return result;
        }
      }
      return 0;
    });
  }
  const [scrollTableWidth,setscrollTableWidth] = useState('101%')
  function calculateZoomLevel() {
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const zoomLevel = ((windowWidth / screenWidth) + (windowHeight / screenHeight)) / 2;
    return Math.round(zoomLevel * 100);
  }
  useEffect(() => {
    let lastZoomLevel = calculateZoomLevel();
    async function getArFukuiWHSeinoLTList() {
      let ArFukuiWHSeinoLTList = "";
      let listInfo = "";
      let postCodeList = []
      let LeadTimeList = []
      let prefecturesList = []
      let prefectureKanaList = []
      let municipalitiesList = []
      let cityKanaList = []
      let townNameList = []
      let townNameKanaList = []
      setProgress(true); // データのロード開始
      try {
        // 全ての情報を取得する
        listInfo = await API.graphql(graphqlOperation(listALLArFukuiWHSeinoLT));
        ArFukuiWHSeinoLTList = listInfo.data.listALLArFukuiWHSeinoLT["items"];
        let nextToken = listInfo.data.listALLArFukuiWHSeinoLT.nextToken;
        while (nextToken !== null) {
          let InvDataSec = await API.graphql(
            graphqlOperation(listALLArFukuiWHSeinoLT, {
              nextToken: nextToken,
            })
          );
          nextToken = InvDataSec.data.listALLArFukuiWHSeinoLT.nextToken;
          for (
            let i = 0;
            i < InvDataSec.data.listALLArFukuiWHSeinoLT.items.length;
            i++
          ) {
            ArFukuiWHSeinoLTList.push(
              InvDataSec.data.listALLArFukuiWHSeinoLT.items[i]
            );
          }
        }
        for (let i = 0; i < ArFukuiWHSeinoLTList.length; i++) {
          if (ArFukuiWHSeinoLTList[i].PostCode) {
            postCodeList.push(ArFukuiWHSeinoLTList[i].PostCode)
            LeadTimeList.push(ArFukuiWHSeinoLTList[i].leadTime)
            prefecturesList.push(ArFukuiWHSeinoLTList[i].Prefectures)
            prefectureKanaList.push(ArFukuiWHSeinoLTList[i].PrefectureKana)
            municipalitiesList.push(ArFukuiWHSeinoLTList[i].Municipalities)
            cityKanaList.push(ArFukuiWHSeinoLTList[i].CityKana)
            townNameList.push(ArFukuiWHSeinoLTList[i].TownName)
            townNameKanaList.push(ArFukuiWHSeinoLTList[i].TownNameKana)
          }
        }
        ArFukuiWHSeinoLTList = multiSort(ArFukuiWHSeinoLTList,sortByPostCode)
        let leadTimeListInfo = Array.from(new Set(LeadTimeList))
        setPostCodeList(Array.from(new Set(postCodeList)))
        setleadTimeList(multiSort(leadTimeListInfo,sortByLeadTime))
        setPrefecturesList(Array.from(new Set(prefecturesList)))
        setPrefectureKanaList(Array.from(new Set(prefectureKanaList)))
        setMunicipalitiesList(Array.from(new Set(municipalitiesList)))
        setCityKanaList(Array.from(new Set(cityKanaList)))
        setTownNameList(Array.from(new Set(townNameList)))
        setTownNameKanaList(Array.from(new Set(townNameKanaList)))
        setArFukuiWHSeinoLTList(ArFukuiWHSeinoLTList);
        setArFukuiWHSeinoLTListCopy(JSON.parse(JSON.stringify(ArFukuiWHSeinoLTList)))
        const handleResize = () => {
          let dom = document.querySelector("#table");
          const newZoomLevel = calculateZoomLevel();
          if (lastZoomLevel !== newZoomLevel) {
            if (newZoomLevel > lastZoomLevel) {
              setscrollTableWidth(dom ? `101%` : `101%`)
            }else {
              let width = dom ? (`${dom.offsetWidth}` < 1632 ? `1632px` : '101%') : '101%';
              setscrollTableWidth(`${width}`)
            }
            lastZoomLevel = newZoomLevel;
          }
        };
        window.addEventListener('resize',handleResize, 100);
        return () => window.removeEventListener('resize', handleResize);
      } catch (err) {
        console.error(err);
      } finally {
        setProgress(false); // ロードが終了したら進行状態を更新
      }
    }
    getArFukuiWHSeinoLTList();
  }, []);
  const headerStyle = {
    backgroundColor: "white",
    borderBottom: "3px solid #B45210",
  };
  let columns1 = [
    { dataField: "id", text: "ID", hidden: true },
    {
      dataField: "leadTime",
      text: "リードタイム",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "140px",minWidth:"140px" },
    },
    {
      dataField: "PostCode",
      text: "郵便番号",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "90px",minWidth:"90px" },
    },
    {
      dataField: "Prefectures",
      text: "都道府県",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "90px",minWidth:"90px" },
    },
    {
      dataField: "PrefectureKana",
      text: "都道府県カナ",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "140px",minWidth:"140px" },
    },
    {
      dataField: "Municipalities",
      text: "市区町村",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "120px",minWidth:"120px" },
    },
    {
      dataField: "CityKana ",
      text: "市区町村カナ",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "150px",minWidth:"150px" },
    },
    {
      dataField: "TownName",
      text: "町名",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "240px",minWidth:"240px" },
    },
    {
      dataField: "TownNameKana",
      text: "町名カナ",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "240px",minWidth:"240px" },
    },
  ];

  return (
    <Container
      style={{
        backgroundColor: "",
        minWidth: "100%",
        minHeight: "74vh",
        position: "relative",
      }}
    >
      <Row
        style={{
           borderRadius: "0.25em",
           color: "purple",
           padding: "0.5em",
            }}
          >
        <div style={{ display: 'flex', marginBottom: "10px",width:"100%"}}>
        <Col>
            <h4 style={{
               textAlign: "left",
               color: "black",
               height: 30,
               width: '20%',
               borderLeft: "4px solid #804F29",
               paddingLeft: "4px",
               whiteSpace:"nowrap"}}>
          福井倉庫西濃LT
          </h4>
        </Col>
        <div style={{ width: '80%', height: 225 }}>
          <div style={{ width: '90%',minWidth:"500px",height: 235, border: '2px solid rgb(191,191,191)', display:'flex', flexWrap: "wrap",justifyContent:"center", padding: "30px 0px 0px 0px" }}>
             <div style={{ width: "50%", height: '25px' }}>
                <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                 <InputGroup.Text
                   className={classes.textlabelSearch}
                   id="basic-name"
                   style={{ borderRadius: "0px",minWidth:"100px"}}
                  >リードタイム
                 </InputGroup.Text>
                 <Autocomplete
                     className={classes.textFieldSearch}
                    sx={{
                      display: 'inline-block',
                      '& input': {
                          height: 0,
                      },
                  }}
                  MenuProps={{
                    PaperProps: {
                    style: { maxHeight: 400 }
                    },
                    }}
                    useVirtual={true}
                    options={leadTimeList}
                    value={searchValue.leadTime}
                    maxLength ="20"
                    onChange={(e, value) => { searchValueChange(e, value,"leadTime") }}
                    name="leadTime"
                    id="leadTime"
                    isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                     renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                 />
                </InputGroup>
             </div>
             <div style={{ width: "50%", height: '25px' }}>
                <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                 <InputGroup.Text
                   className={classes.textlabelSearch}
                   id="basic-name"
                   style={{ borderRadius: "0px",minWidth:"100px"}}
                  >郵便番号
                 </InputGroup.Text>
                 <Autocomplete
                     className={classes.textFieldSearch}
                    sx={{
                      display: 'inline-block',
                      '& input': {
                          height: 0,
                      },
                  }}
                  MenuProps={{
                    PaperProps: {
                    style: { maxHeight: 400 },
                    },
                    }}
                    useVirtual={true}
                    options={PostCodeList}
                    value={searchValue.PostCode}
                    maxLength ="20"
                    onChange={(e, value) => { searchValueChange(e, value,"PostCode") }}
                    name="PostCode"
                    id="PostCode"
                    isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                     renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                 />
                </InputGroup>
             </div>
             <div style={{ width: "50%", height: '25px' }}>
                <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                 <InputGroup.Text
                   className={classes.textlabelSearch}
                   id="basic-name"
                   style={{ borderRadius: "0px",minWidth:"100px"}}
                  >都道府県
                 </InputGroup.Text>
                 <Autocomplete
                     className={classes.textFieldSearch}
                    sx={{
                      display: 'inline-block',
                      '& input': {
                          height: 0,
                      },
                  }}
                  MenuProps={{
                    PaperProps: {
                    style: { maxHeight: 400 },
                    },
                    }}
                    useVirtual={true}
                    options={PrefecturesList}
                    value={searchValue.Prefectures}
                    maxLength ="20"
                    onChange={(e, value) => { searchValueChange(e, value,"Prefectures") }}
                    name="Prefectures"
                    id="Prefectures"
                    isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                     renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                 />
                </InputGroup>
             </div>
             <div style={{ width: "50%", height: '25px' }}>
                <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                 <InputGroup.Text
                   className={classes.textlabelSearch}
                   id="basic-name"
                   style={{ borderRadius: "0px",minWidth:"100px"}}
                  >都道府県カナ
                 </InputGroup.Text>
                 <Autocomplete
                     className={classes.textFieldSearch}
                    sx={{
                      display: 'inline-block',
                      '& input': {
                          height: 0,
                      },
                  }}
                  MenuProps={{
                    PaperProps: {
                    style: { maxHeight: 400 },
                    },
                    }}
                    useVirtual={true}
                    options={PrefectureKanaList}
                    value={searchValue.PrefectureKana}
                    maxLength ="20"
                    onChange={(e, value) => { searchValueChange(e, value,"PrefectureKana") }}
                    name="PrefectureKana"
                    id="PrefectureKana"
                    isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                     renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                 />
                </InputGroup>
             </div>
             <div style={{ width: "50%", height: '25px' }}>
                <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                 <InputGroup.Text
                   className={classes.textlabelSearch}
                   id="basic-name"
                   style={{ borderRadius: "0px",minWidth:"100px"}}
                  >市区町村
                 </InputGroup.Text>
                 <Autocomplete
                     className={classes.textFieldSearch}
                    sx={{
                      display: 'inline-block',
                      '& input': {
                          height: 0,
                      },
                  }}
                  MenuProps={{
                    PaperProps: {
                    style: { maxHeight: 400 },
                    },
                    }}
                    useVirtual={true}
                    options={MunicipalitiesList}
                    value={searchValue.Municipalities}
                    maxLength ="20"
                    onChange={(e,value) => { searchValueChange(e,value,"Municipalities") }}
                    name="Municipalities"
                    id="Municipalities"
                    isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                     renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                 />
                </InputGroup>
             </div>
             <div style={{ width: "50%", height: '25px' }}>
                <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                 <InputGroup.Text
                   className={classes.textlabelSearch}
                   id="basic-name"
                   style={{ borderRadius: "0px",minWidth:"100px"}}
                  >市区町村カナ
                 </InputGroup.Text>
                 <Autocomplete
                     className={classes.textFieldSearch}
                    sx={{
                      display: 'inline-block',
                      '& input': {
                          height: 0,
                      },
                  }}
                  MenuProps={{
                    PaperProps: {
                    style: { maxHeight: 400 },
                    },
                    }}
                    useVirtual={true}
                    options={CityKanaList}
                    value={searchValue.CityKana}
                    maxLength ="20"
                    onChange={(e, value) => { searchValueChange(e, value,"CityKana") }}
                    name="CityKana"
                    id="CityKana"
                    isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                     renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                 />
                </InputGroup>
             </div>
             <div style={{ width: "50%", height: '25px' }}>
                <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                 <InputGroup.Text
                   className={classes.textlabelSearch}
                   id="basic-name"
                   style={{ borderRadius: "0px",minWidth:"100px"}}
                  >町名
                 </InputGroup.Text>
                 <Autocomplete
                     className={classes.textFieldSearch}
                    sx={{
                      display: 'inline-block',
                      '& input': {
                          height: 0,
                      },
                  }}
                  MenuProps={{
                    PaperProps: {
                    style: { maxHeight: 400 },
                    },
                    }}
                    useVirtual={true}
                    options={TownNameList}
                    value={searchValue.TownName}
                    maxLength ="20"
                    onChange={(e, value) => { searchValueChange(e, value,"TownName") }}
                    name="TownName"
                    id="TownName"
                    isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                     renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                 />
                </InputGroup>
             </div>
             <div style={{ width: "50%", height: '25px' }}>
                <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                 <InputGroup.Text
                   className={classes.textlabelSearch}
                   id="basic-name"
                   style={{ borderRadius: "0px",minWidth:"100px"}}
                  >町名カナ
                 </InputGroup.Text>
                 <Autocomplete
                     className={classes.textFieldSearch}
                    sx={{
                      display: 'inline-block',
                      '& input': {
                          height: 0,
                      },
                  }}
                  MenuProps={{
                    PaperProps: {
                    style: { maxHeight: 400 },
                    },
                    }}
                    useVirtual={true}
                    options={TownNameKanaList}
                    value={searchValue.TownNameKana}
                    maxLength ="20"
                    onChange={(e, value) => searchValueChange(e, value,"TownNameKana")}
                    name="TownNameKana"
                    id="TownNameKana"
                    isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                     renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                 />
                </InputGroup>
             </div>
             <div style={{margin:"auto"}}>
               <Button className="btn" onClick={() => searchBtn()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: "3px solid black", background: "white",marginRight:'10px'}}>検索</Button>
                 <Button className="btn" onClick={() => searchClear()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: '3px solid black', background: "white"}}>Clear</Button>
             </div>
          </div>
        </div>
        </div>
      </Row>
      <div
            style={{
              width: "100%",
              height: "100%",
              overflowX: "scroll",
              transform: "scaleY(-1)",
            }}
          >
            <div
              style={{
                width: scrollTableWidth,
                height: "65vh",
                overflowY: "scroll",
                overflowX: "hidden",
                transform: "scaleY(-1)",
              }}
            >
            <div style={{ direction: "ltr" }}>
        <BootstrapTable
          id="table"
          striped={true}
          hover={true}
          wrapperClasses="boo bg-white"
          bootstrap4
          keyField="id"
          data={ArFukuiWHSeinoLTList}
          columns={columns1}
          noDataIndication={"no results found"}
          pagination={paginationFactory(options)}
          headerClasses={classes.fixedTop}
          />
        </div>
        </div>
      </div>
      {/* CircularProgress: ローディング状態を表示 */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <CircularProgress
          size="3rem"
          disableShrink
          sx={{
            color: "#3f51b5",
            margin: "auto",
            display: progress ? "block" : "none",
            marginLeft: "60px",
          }}
        />
      </div>
    </Container>
  );
};

export default ArFukuiWHSeinoLTList;
